














import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { PropType } from '@vue/composition-api';
import { computed, ref, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  props: {
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      required: true,
    },
    error: {
      type: String,
      default: '',
    },
    didYouMean: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const emailInput = ref(props.recipient.email || '');

    const errorMessage = computed((): string => {
      if (!props.error) {
        return '';
      }
      if (props.didYouMean) {
        return `${t('email-error-did-you-mean')}: ${props.didYouMean}`;
      }
      if (props.error === 'Unreachable') {
        return `${t('could-not-verify-email-address')}`;
      }
      return t('could-not-sign-up');
    });

    const handleInput = () => {
      emit('email', emailInput.value);
    };

    return {
      emailInput,
      errorMessage,
      handleInput,
    };
  },
});
